module.exports = __webpack_public_path__ + "img/profile-picture-jaya-min.550416a5.png";